import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useThemeContext } from "../../../Context/ThemeContext";
import AbsenColumns from "../constants/TableColumns";
import DateFilterComponent from "./filter/DateFilterComponent";
import AbsenPNSColumns from "../constants/TableColumnsAbsenPNS";
import { SearchBar } from "../../../CommonElements";
import { useStaf } from "../../../Context/StafContext";

const AbsenList = ({
  data,
  dateFilter,
  isPNS,
  updateDateFilter,
  toggleIsPNS,
  resetState,
  pending,
}) => {
  const stafAPI = useStaf();
  const { themeContext } = useThemeContext();

  const [updatedData, setUpdatedData] = useState([]);
  const [filterStaf, setFilterStaf] = useState("");
  const [options, setOptions] = useState({
    Grup: [],
  });
  const [selectedItems, setSelectedItems] = useState({
    Grup: [],
  });

  useEffect(() => {
    refreshGroupStaf();
  }, []);

  const refreshGroupStaf = () => {
    stafAPI.getGroupStaf().then((res) => {
      const mappedStatus = res.data.map((item) => ({
        id: item.id_group,
        name: item.nama,
      }));

      setOptions((prev) => ({
        ...prev,
        Grup: mappedStatus,
      }));
    });
  };

  useEffect(() => {
    let newData = data.staf ?? [];

    if (isPNS)
      newData = newData.filter(
        (item) =>
          item.status_staf === 5 ||
          (item.status_staf !== 3 &&
            item.golongan_pns &&
            item.golongan_pns.match("[I]"))
      );

    if (selectedItems.Grup.length > 0) {

      newData = newData.filter((item) =>
        selectedItems.Grup.includes(item.group_staf)
      );
    }

    newData = newData.filter(
      (item) =>
        item.nama?.toLowerCase().includes(filterStaf.toLowerCase()) ||
        item.group_nama?.toLowerCase().includes(filterStaf.toLowerCase())
    );

    newData = newData.map((item) => {
      const absen = findAbsen(item, data?.absen);
      return { ...item, absen: absen };
    });

    newData = newData.map((item) => {
      const detailAbsen = filterDetailAbsen(item?.absen, data?.detailAbsen);
      return {
        ...item,
        datang: findAbsenDatang(detailAbsen),
        pulang: findAbsenPulang(detailAbsen),
      };
    });

    setUpdatedData(newData);
  }, [data.staf, data.absen, data.detailAbsen, filterStaf, isPNS, selectedItems]);

  const findAbsen = (staf, absenList) =>
    absenList?.find((item) => staf.nama === item.id_user);
  const filterDetailAbsen = (absen, detailAbsenList) =>
    detailAbsenList?.filter((item) => absen?.id_absensi === item.id_absensi);
  const findAbsenDatang = (detailAbsenList) =>
    detailAbsenList?.find((item) => item.mode === 1);
  const findAbsenPulang = (detailAbsenList) =>
    detailAbsenList?.find((item) => item.mode === 2);

  const subHeaderComponent = (
    <div className="d-flex w-100 flex-column gap-3">
      <SearchBar className={"align-items-end ms-auto"} onChange={(e) => setFilterStaf(e.target.value)} />
      <DateFilterComponent
        updateDateFilter={updateDateFilter}
        filter={true}
        options={options}
        setState={setSelectedItems}
        state={selectedItems}
      />
    </div>
  );

  return (
    <DataTable
      data={updatedData}
      columns={
        isPNS
          ? AbsenPNSColumns(data?.absen)
          : AbsenColumns(resetState, dateFilter)
      }
      pagination
      selectableRowsHighlight
      highlightOnHover
      subHeader
      subHeaderComponent={subHeaderComponent}
      subHeaderAlign="right"
      persistTableHead
      progressPending={pending}
      theme={themeContext}
      defaultSortFieldId={4}
      defaultSortAsc={false}
    />
  );
};

export default AbsenList;
